import Button from 'components/button'
import textServices from 'services/text-services'
import useMainClass from 'hooks/use-main-cass'
import useRouter from 'hooks/use-router'
import ButtonCloseMenu from 'components/button-close'
import { ContainerSurveyQr } from '../styles/styled.components'

function SurveyCover({ handleClick }: { handleClick: () => void }) {
  useMainClass('survey-qr__cover')
  const { history } = useRouter()

  return (
    <ContainerSurveyQr className="flex-1 w-full flex flex-col gap-6 py-7">
      <ButtonCloseMenu
        open={true}
        paramFn={handleClick}
      />
      {textServices?.findByText('survey/cover/html', "")}
      <div className="w-full px-7 flex flex-col items-center">
        <Button onClick={handleClick}>{textServices?.findByText('survey/cover/button', { es: 'COMENCEMOS', en: 'START' })}</Button>
        <button type="button" className="cursor-pointer back-button" onClick={() => history.push('/home')}>
          {textServices.findByText('backButton', { es: 'VOLVER', en: 'BACK TO' })}
        </button>
      </div>
    </ContainerSurveyQr>
  )
}

export default SurveyCover